var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditTypeCategoryWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "url(#pattern0_1372_93)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1372_93",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1372_93",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1372_93",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAA0JJREFUeJztmj1v00AYx58ERFU6wdaSpHwHPkA6sCAoCzMICaZSia/ARlfWjswwIcqKGAoMhVRiYEFIkNIhGRAw0cCPwRdqub4X2xdfEvsnefH5nue5v+/Nj0+kpqamZg4ATgO3gVfAAPgFvAE2gTOh45sowHngLXreAxdCxzkRgKal8WPezWVPAG46NH7MvdDx5ga4CvQdGvkcaKlrJ1H2OnQ7cgN8dXzLrViddqLsR9Jus9xmFKJlfyQ7sySAK9vqzbdFZDtR9iFEQF5I9vPY/SyT4EbINhTCIECTaMNjY49ZXgZ1AqiycxYR9oCVULF7wSSAKj8F3AJeEm2FfwK7wMbE3zywCmwBB+raAlY9+zAKEATgEvAYOErpdn+AZ8BloOHB13QIACyortYzjLkkH4H7wFIBv2EFAFaAB2p85eU78Ai4mMN/GAGANeApMLI0rgfcVZetd4yUzbUMcZQnAO7dXDvOMc8PcZyGR2kCANexd/Mh0UzfcbDXUc8OLTYHwLrBTmkCfDMEuU/UxRdz2F1UdfcN9g8M9SciQNrH0LLh+QURWRKRPMvaXxH5LSKm4MPv1izddIzzbA4sk2H1cI3La6NNjiyMgCdAN8VOV5XZVg8vAuArK5wS07ghttk8yzJ4pGx2fQiAz6ywzhHRbP4Q+2xuYqhsdGz+MsTlNytsC4hoNr9Dtq1wT9U5sXp4EMBvVtg1IPVsF/3w+N/N8/gDbmBeknUUywpnESBWp5MSiHWTZBHgMEfjIURWuNFofHG5N41Mc1Z4U0QOc9QrlhXOMwTKqGcYKn6zwjMogN+s8KwJoMr8ZYVnUQBV7icrnKJeoeXMUufE8unTvgsuq8BnPGZ3RY6zRSLyyYc9rxDl9XVoEyIOXdRlC903xDWRHpDmaJ0cKTFdgLh/RA2Aa8EFUM5c0ldg+KzF/TPaKc1WqgAJx67Z3Sxk/msUTIBYANX8MZISSJFfY2cL+J0OAeJQxZ+jaXD8e7yvrmr8Hi8TmwDM+1lhkwBU4aywTgCqclbYIEBlzgq7MrdnhV2Z27PC2i/FSgBcwe3E+I56823gRaJsN3Q7vENVzgrroCpnhU1QhbPCNgh5VrimpmZm+QfxaPYxpIgTfgAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditTypeCategoryWhite);
export default __webpack_public_path__ + "static/media/Audit Type Category_White.342020927881273e0cb0b79e1e46a507.svg";
export { ForwardRef as ReactComponent };